//store/modules/auth.js
import axios from "axios";
const state = {
	user: null,
	defaultSiteId: null,
	defaultSiteName: '',
	apiURL: "https://api.knowatt.com"
};
const getters = {
	getUser: (state) => state.user,
	isAuthenticated: (state) => !!state.user,
	getDefaultSiteId: (state) => state.defaultSiteId,
	defaultSiteName: (state) => state.defaultSiteName
};
const mutations = {
	setUser(state, user) {
		state.user = user;
	},
	setUserName(state, name) {
		state.user.name = name;
	},
	setDefaultSiteId(state, id) {
		state.defaultSiteId = id;
	},
	setDefaultSiteName(state, name) {
		state.defaultSiteName = name;
	},
	LogOut(state) {
		state.user = null;
	},
	setGateway(state, gateway) {
		state.user.gateway = gateway;
	}
};
const actions = {
	async LogIn({ commit, state }, User) {
		const { data } = await axios.post(state.apiURL + "/user/login.php", User);
		localStorage.setItem('access_token', data.token);
		await commit("setDefaultSiteId", data['siteId']);
		await commit("setDefaultSiteName", data['site']);
		await commit("setUser", data);
		return data;
	},
	async LogOut({ commit }) {
		let user = null;
		await commit("LogOut", user);
		localStorage.removeItem('access_token');
	},
	async ForgotPassword({ commit, state }, email) {
		const { data } = await axios.post(state.apiURL + "/user/forgot.php", { email: email });
		return data;
	},
	async ResetPassword({ commit, state }, pData) {
		const { data } = await axios.post(state.apiURL + "/user/reset.php", {
			token: pData['token'],
			password: pData['password']
		});
		return data;
	},
	async updateUser({ commit, state }, payload) {
		const { data } = await axios.post(state.apiURL + "/user/update.php", payload);
		await commit("setUserName", data[0].name);
		return data[0]
	},
	async createUser({ commit, state }, payload) {
		const { data } = await axios.post(state.apiURL + "/user/create.php", payload);
		return data;
	},
	async setUserSites({ commit, state }, site) {
		const { data } = await axios.post(state.apiURL + "/user/setUserSite.php", site);
		await commit("setDefaultSiteName", data['site']);
		await commit("setDefaultSiteId", data['siteId']);
		await commit("setUser", data);
		return data;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
